const styles = theme => ({
  root: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)"
  }
})

export default styles



// WEBPACK FOOTER //
// ./src/components/PostLoading/styles.js